/**
 * The suite never shows the browser's own right-click menu (Back, Save page as, Inspect…), not even
 * in text fields: screens show the suite's menus instead (useContextMenu, AppShell, and TextFieldMenu
 * with Cut, Copy, Paste and Select all for text fields).
 * Returns a function that removes the guard.
 */
export function installContextMenuGuard(doc: Document = document): () => void {
  const onContextMenu = (e: MouseEvent): void => {
    e.preventDefault();
  };
  doc.addEventListener("contextmenu", onContextMenu);
  return () => doc.removeEventListener("contextmenu", onContextMenu);
}
